import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { Downloading, TargetSettingsDownload } from 'types/Downloading';

export const defaultDownloadingState: Downloading = {
  status: null,
  modalShown: false,
  taskId: null,
  rasterisationProgress: 0
};

export const updateDownloading = createActionCreator(
  'DOWNLOADING/UPDATE',
  resolve => (downloading: Partial<Downloading>) => resolve(downloading)
);
export const download = createActionCreator(
  'DOWNLOADING/DOWNLOAD',
  resolve => (settings: TargetSettingsDownload) => resolve(settings)
);

export const restoreDownloading = createActionCreator('DOWNLOADING/RESTORE_DOWNLOADING');
export const exportTemplate = createActionCreator('DOWNLOADING/EXPORT_TEMPLATE');
export const closeModal = createActionCreator('DOWNLOADING/CLOSE_MODAL');
export const cancelProcessing = createActionCreator('DOWNLOADING/CANCEL_PROCESSING');

export const downloading = createReducer(defaultDownloadingState, handle => [
  handle(updateDownloading, (state, { payload }) => ({ ...state, ...payload })),
  handle(closeModal, state => ({
    ...state,
    modalShown: false
  }))
]);

export const getDownloadingState = (state: AppState): Downloading => state.downloading;
